import { render } from "./BackpageButton.vue?vue&type=template&id=6775fe88&scoped=true"
import script from "./BackpageButton.vue?vue&type=script&lang=js"
export * from "./BackpageButton.vue?vue&type=script&lang=js"

import "./BackpageButton.vue?vue&type=style&index=0&id=6775fe88&scoped=true&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6775fe88"]])

export default __exports__